import { Tablet } from '@/styles/layout';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';

const MainBannerSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [opacity, setOpacity] = useState<number>(0);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const calculate = () => {
      if (!ref.current) {
        return;
      }
      const sectionHeight = ref.current.clientHeight;
      const scrollY = window.scrollY;

      const scrollRatio = scrollY / sectionHeight;

      const opacity = scrollRatio > 1 ? 1 : scrollRatio;
      setOpacity(opacity);
    };

    window.addEventListener('scroll', calculate);
    return () => {
      window.removeEventListener('scroll', calculate);
    };
  }, []);

  return (
    <MainBanner ref={ref} opacity={opacity}>
      <div className='flex max-w-[1080px] flex-col px-[24px] pt-[52px] pb-[40px] lg:pt-[128px] lg:pb-[96px]'>
        <div
          className='typography-ui-17sb typography-ui-14r mb-[12px] text-gray-400'
          style={{
            opacity: 1 - opacity,
          }}
        >
          * 2024 주간동아 <span className='typography-ui-14b'>한국고객만족도 비대면 진료 앱 1위</span>
        </div>
        <h1 className='typography-ui-28b lg:typography-ui-56b mb-[24px] text-gray-900'>
          대한민국 1위 비대면 진료 앱<br />
          아플 땐 닥터나우
        </h1>
        <div className='mb-[64px] flex flex-col justify-between gap-y-[40px] lg:flex-row'>
          <div className='typography-ui-22sb text-gray-500'>
            아픈 모든 순간, 닥터나우가
            <br />
            가장 빠르고 편리하게 해결해 드릴게요.
          </div>
          <div className='typography-ui-15sb lg:typography-ui-17sb flex h-[40px] w-fit items-center rounded-[8px] bg-primary-600 px-[16px] py-[8px] text-white lg:h-[56px] lg:rounded-[12px]'>
            <Link href={'/telemedicine/doctors'}>
              <a>서비스 둘러보기</a>
            </Link>
          </div>
        </div>
        <div
          style={{
            opacity: 1 - opacity,
          }}
        >
          <img
            src={'https://file.doctornow.co.kr/landing/main_banner_section.png'}
            alt='비대면 진료 앱 이미지'
            className={'h-auto max-h-[480px] w-full max-w-[1050px] rounded-[8px] lg:rounded-[32px]'}
          />
        </div>
      </div>
    </MainBanner>
  );
};

export default MainBannerSection;

const MainBanner = styled.div<{ opacity: number }>`
  position: fixed;
  width: 100vw;
  height: 1089px !important;

  background-size: cover;
  background-position: center;
  background-color: white;

  display: flex;
  flex-direction: column;
  align-items: center;
  isolation: isolate;

  @media screen and (max-width: ${Tablet}) {
    width: 100%;
    height: 1089px !important;
    background-color: white;
  }

  &::after {
    content: '';
    position: absolute;
    background: #2d2e2f;
    z-index: 1;
    inset: 0;
    opacity: ${({ opacity }) => opacity * 1.1};
  }

  ${({ theme }) =>
    !theme.client.isMobile &&
    css`
      &::before {
        position: absolute;
        width: 0;
        height: 0;
        overflow: hidden;
        z-index: -1;

        content: url('https://file.doctornow.co.kr/landing/catchphrase.png')
          url('https://file.doctornow.co.kr/landing/cf-web-main-thumbnail.jpg');
      }
    `}
`;
